<template>
  <div class="info">
    <!-- banner -->
    <div class="banner">
      <img src="/imgs/b1.jpg" alt="" />
    </div>
    <div class="container">
      <!-- 标题 -->
      <div class="at-title">
        <h2>公司简介</h2>
        <h4>Company profile</h4>
      </div>

      <div class="info-con">
        <p>
          北京多用信息技术有限公司前身为时代光华无线事业部门，经过两年的孵化培育，于2013年10月正式变身为“北京多用信息技术有限公司"起航出海。
        </p>
        <p>
          公司始终致力于提供给个人用户更有效的学习体验，伴随用户闯荡职场，成长提高。
        </p>
        <p>
          北京多用信息技术有限公司从创办开始，就一直致力于个人培训学习的产品化、产业化和产业链化。经过多年的积累、发展与转型，已逐步从内容资源供应商，升级为基于网络的组织学习方案服务商，并向着产业链平台运营商迈进。目前以个人网络学习服务为主业，业务涵盖内容、平台、课件软件定制、移动学习、多媒体产品、教材、公开课、内训、组织学习咨询服务等领域。
        </p>
        <p>
          北京多用以持续创造客户价值为导向，为个人学习提供专业解决方案。通过学习打造个人能力，实现个人持续发展。坚持“内容为魂，平台为用，服务为本，运营为王”，致力于成为国内管理培训、职场教育领域的领跑者。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "info",
  components: {},
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "北京多用信息技术有限公司";
  },
  methods: {
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.info {
  .banner {
    width: 100%;
    height: 400px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .container {
    //   标题
    .at-title {
      width: 100%;
      height: 40px;
      border-left: 4px solid $colorZ;
      padding-left: 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      margin: 20px auto;
      h2 {
        font-size: 21px;
        color: #555;
      }
      h4 {
        font-size: 12px;
        color: #888;
      }
    }
    .info-con {
      p {
        font-size: 14px;
        line-height: 50px;
        color: #555;
        text-indent: 40px;
      }
    }
  }
}
</style>
